import {isEmpty, isNotEmpty} from "./type-utils.js";
import MoveTo from "moveto";
import {executeOnLoad} from "./event-utils.js";

/**
 * Checks if an Element is visible on the screen
 *
 * @param elem {HTMLElement} element to check
 *
 * @returns {boolean} True if the element is visible
 */
export function isScrolledIntoView(elem) {

    if (isEmpty(elem)) {
        return null;
    }

    let docViewTop = window.scrollY,
        docViewBottom = docViewTop + window.innerHeight;

    // account for sticky tab/header and sticky footer
    const stickyTab = document.querySelector('.sticky-tab.is-sticky-overlay.is-visible'),
        header = document.querySelector('header'),
        stickyFooter = document.querySelector('.sticky-footer'),
        stickyTabHeight = isNotEmpty(stickyTab) && isElementInViewport(stickyTab) ? stickyTab.getBoundingClientRect().height : 0,
        headerHeight = isNotEmpty(header) && isElementInViewport(header) ? header.getBoundingClientRect().height : 0,
        stickyFooterHeight = isNotEmpty(stickyTab) && isElementInViewport(stickyFooter) ? stickyFooter.getBoundingClientRect().height : 0;

    docViewTop += Math.max(headerHeight, stickyTabHeight);
    docViewBottom -= stickyFooterHeight;

    const elemTop = window.scrollY + elem.getBoundingClientRect().top,
        elemBottom = elemTop + elem.clientHeight;

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}


/**
 * Check if the Element is visible on the viewport
 * Does *not* account for overlapping elements, use #isScrolledIntoView() for this
 *
 * @param elem
 * @returns {null|boolean}
 */
function isElementInViewport(elem) {
    if (isEmpty(elem)) {
        return null;
    }

    const docViewTop = window.scrollY,
        docViewBottom = docViewTop + window.innerHeight;

    const elemTop = window.scrollY + elem.getBoundingClientRect().top,
        elemBottom = elemTop + elem.clientHeight;

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

/**
 * Scrolls smoovely to the passed element
 * @param element {HTMLElement}
 * @param moveToOptions {Object} Optional settings passed to the NoveTo Object
 */
export function scrollIntoView(element, moveToOptions = {}) {
    const moveTo = new MoveTo(moveToOptions);

    executeOnLoad(() => {
        moveTo.move(element);
    });

}


export function disableBodyScroll() {
    const scrollElement = document.scrollingElement || document.querySelector('html');

    scrollElement.style.top = `-${window.scrollY}px`;
    scrollElement.classList.add('noscroll');
}

export function enableBodyScroll() {
    const scrollElement = document.scrollingElement || document.querySelector('html');

    const scrollY = scrollElement.style.top;
    scrollElement.classList.remove('noscroll');
    scrollElement.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
}

/**
 * Scrolls smoovely to the top of the page
 * @param moveToOptions {Object} Optional settings passed to the NoveTo Object
 */
export function smoothScrollToTop(moveToOptions = {}) {
    const moveTo = new MoveTo(moveToOptions);

    executeOnLoad(() => {
        moveTo.move(document.querySelector("body"));
    });
}